<template>
  <div class="order-details">
      <rCenterHeader :list="headerMenu"></rCenterHeader>
      <div class="details">
          <rOrderDetails></rOrderDetails>
      </div>
  </div>
</template>

<script>
import rCenterHeader from "../../components/r-center-header";
import rOrderDetails from "../../components/r-order-details";

export default {
  name: "order-details",
  components:{
      rCenterHeader,
      rOrderDetails,
  },
  data() {
    return {
        // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.myOrder"),
          to:'./myOrder'
        },
        {
          name: this.$t("customer.crumbs.details"),
        },
      ]
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.order-details{

}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/orderDetails.vue